import { Box, Typography } from '@mui/material';

const counterCardColor = {
  info: {
    '& .statusCounter-card__title': {
      color: '#034220 !important',
    },
  },
  expiring: {
    '& .statusCounter-card__title': {
      color: '#F15A24 !important',
    },
  },
  expired: {
    '& .statusCounter-card__title': {
      color: '#DD2F2F !important',
    },
  },
};

export const StatusCounterCard = (props: {
  variant: keyof typeof counterCardColor;
  count: number;
  caption: string;
  countLabel: string;
}) => {

  if (props.count === 0 && props.variant !== 'info') return null;

  return (
    <Box
      className="statusCounter-card"
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E1E5E3',
        boxShadow: '0 1px 2px rgba(1, 16, 8, 0.12)',
        ...counterCardColor[props.variant],
      }}
    >
      <Typography
        className="statusCounter-card__title"
        component="h3"
        sx={{ fontWeight: 600 }}
      >
        {props.caption}
      </Typography>
      <Typography
        component="p"
        sx={{
          color: '#1F1F1F',
          fontSize: '1.25rem',
          fontWeight: 600,
        }}
      >
        {props.countLabel}
      </Typography>
    </Box>
  );

};
